export default __webpack_public_path__ + "008434e2dd7946f1902369db480505ef.png";